module.exports = __webpack_public_path__ + "static/media/hashunitedlogo.c41f49ab.svg";